import { z } from "zod";
import { AccountSchema } from "./Account"; 
import { UserSchema } from "../user";

export const CreateAccountRequestSchema = AccountSchema.pick({
    name: true,
    fiscalNumber: true,
    address: true, 
    zipCode: true, 
    city: true,  
    email: true,  
    phoneNumber: true,
    description: true,
    allowExternalManagers: true,
    maxInternalManagers: true
}).extend({
    user: UserSchema.pick({
        name: true,
        email: true,
        password: true,
        roleId: true,
        phoneNumber: true
    })
});

export type CreateAccountRequest = z.infer<typeof CreateAccountRequestSchema>;